import { ReactComponent as StarBlack } from "assets/images/starBlack.svg"
import { ReactComponent as StarGrey } from "assets/images/starGrey.svg"
import { times } from "lodash-es"
import { modifiers } from "ui-tools"
import s from "./Stars.module.scss"

type StarSize = "extraSmall" | "small" | "medium" | "large"

export const Stars = ({
  count,
  max,
  size = "medium",
  ariaLabel,
  emptyStarColor = "default",
}: {
  count: number
  max: number
  size?: StarSize
  ariaLabel?: string
  emptyStarColor?: "default" | "concrete"
}) => {
  ariaLabel = ariaLabel || `${count} of ${max} stars`

  return (
    <div
      className={modifiers(s, "star", size, {
        emptyConcrete: emptyStarColor === "concrete",
      })}
      role="img"
      aria-label={ariaLabel}
      style={{ color: "var(--company-star-color)" }}
    >
      {times(max, (index) =>
        index < count ? (
          <StarBlack key={index} />
        ) : (
          <StarGrey key={index} className={s.star__empty} />
        )
      )}
    </div>
  )
}
